import { getPropsForClickTracking } from "../../utils/tracking";
$ const { open, postalCodePillData, userLocationZipcode } = input;
$ const { zipcodeValue, distanceValue, showErrorMessage } = state;
$ const { updateLocationModal = {} } = postalCodePillData || {};
$ const {
  postalCodeEntry = {},
  actions = [],
  closeOverlay,
  distanceSlider,
} = updateLocationModal;
$ const { title: postalCodeEntryTitle } = postalCodeEntry;
$ const closeAction = actions?.find((item: any) => item?.action?.name === "CANCEL_UPDATE_LOCAL_LOCATION");
$ const updateAction = actions?.find((item: any) => item?.action?.name === "APPLY_UPDATE_LOCAL_LOCATION");
$ const disableSubmit = !zipcodeValue || !distanceValue;
$ const useSlider = !!distanceSlider;

<ebay-lightbox-dialog
  open=open
  size="narrow"
  a11yCloseText=closeOverlay?.accessibilityText
  class="change-location-dialog"
  on-close("emit", "close")
  ...getPropsForClickTracking(closeOverlay?.trackingList)
>
  <@header>
    <div class="change-location-dialog__title" data-testid="change-location-dialog-title">
      <fe-textual-display model=postalCodeEntryTitle/>
    </div>
  </@header>

  <@footer>
    <div class="change-location-dialog__footer">
      <ebay-button
        data-testid="change-location-dialog-footer-btn-close"
        priority="tertiary"
        on-click("emit", "close")
        ...getPropsForClickTracking(closeAction?.action?.trackingList)
      >
        <fe-textual-display model=closeAction?.text/>
      </ebay-button>

      <ebay-button
        data-testid="change-location-dialog-footer-btn-submit"
        priority="primary"
        on-click("onSubmit")
        disabled=disableSubmit
        ...getPropsForClickTracking(updateAction?.action?.trackingList)
      >
        <fe-textual-display model=updateAction?.text/>
      </ebay-button>
    </div>
  </@footer>

  <div class="change-location-dialog__form">
    <map-location-form
      updateLocationModal=updateLocationModal
      userLocationZipcode=userLocationZipcode
      zipcodeValue=zipcodeValue
      distanceValue=distanceValue
      distanceVariant=(useSlider ? "slider" : "radio")
      showErrorMessage=showErrorMessage
      on-postcode-change("onPostCodeTextboxChange")
      on-use-user-zipcode("useUserZipcode")
      on-distance-change("onDistanceOptionChange")
    />
  </div>
</ebay-lightbox-dialog>
